<template>
  <v-container>
    <p>Non trouvé</p>
  </v-container>
</template>

<script>
function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  data() {
    return {
      isMobile: isMobileDevice(),
    };
  }
};
</script>
